import CardIcon from "./CardIcon";

export default CardIcon;



// WEBPACK FOOTER //
// ./src/apps/payment/components/CreditCardForm/CardIcon/index.js